import { Article, articles } from "@/mocks/gossip";

export default function Featured({ onOpen }: { onOpen: (article: Article) => void }) {
  return (
    <section id="featured" className="scroll-mt-28 bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="flex flex-col justify-between gap-4 md:flex-row md:items-end">
          <div className="max-w-2xl">
            <span className="text-xs font-bold uppercase tracking-widest text-primary-600">Deep Dive</span>
            <h2 className="mt-2 font-heading text-3xl font-black tracking-tight text-foreground-950 md:text-4xl">
              深扒专题：把瓜吃透的完整路径
            </h2>
            <p className="mt-3 text-sm leading-7 text-foreground-600">
              每一篇都按「锁源 → 拉线 → 交叉 → 补境」四步整理。点击任意一篇，进入可逐层展开的深度阅读面板。
            </p>
          </div>
          <a href="#method" className="flex items-center gap-1 text-sm font-semibold text-primary-600 hover:text-primary-700">
            先看我们的还原方法
            <i className="ri-arrow-down-line h-4 w-4"></i>
          </a>
        </div>

        <div className="mt-8 space-y-6">
          {articles.map((a, i) => {
            const flip = i % 2 === 1;
            return (
              <article
                key={a.id}
                className="grid items-stretch overflow-hidden rounded-2xl border border-background-200 bg-background-100/50 md:grid-cols-2"
              >
                <button
                  type="button"
                  onClick={() => onOpen(a)}
                  className={`group relative block aspect-[16/10] w-full cursor-pointer overflow-hidden bg-background-200 md:aspect-auto ${
                    flip ? "md:order-last" : ""
                  }`}
                  aria-label={`打开专题：${a.title}`}
                >
                  <img
                    src={a.cover}
                    alt={`${a.title} 深度解析配图`}
                    title={`${a.title} 深扒内幕细节与真相还原`}
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                  <span className="absolute left-3 top-3 rounded-full bg-primary-500 px-3 py-1 text-xs font-semibold text-background-50">
                    {a.category}
                  </span>
                </button>

                <div className="flex flex-col justify-center p-6 md:p-8">
                  <div className="flex flex-wrap items-center gap-2 text-xs text-foreground-600">
                    <span className="whitespace-nowrap">发布于 {a.date}</span>
                    <span className="h-1 w-1 rounded-full bg-foreground-300"></span>
                    <span className="whitespace-nowrap">约需 {a.readMin} 分钟</span>
                    <span className="flex items-center gap-1 whitespace-nowrap text-accent-700">
                      <i className="ri-verified-badge-fill h-3.5 w-3.5"></i>
                      信源可溯源
                    </span>
                  </div>
                  <h3 className="mt-3 font-heading text-xl font-black leading-snug text-foreground-950 md:text-2xl">
                    {a.title}
                  </h3>
                  <p className="mt-3 line-clamp-3 text-sm leading-7 text-foreground-600">{a.lead}</p>

                  <div className="mt-4 flex flex-wrap gap-2">
                    {a.tags.map((t) => (
                      <span key={t} className="rounded-full bg-background-100 px-2.5 py-1 text-xs text-foreground-700 ring-1 ring-background-200">
                        # {t}
                      </span>
                    ))}
                  </div>

                  <div className="mt-6 flex flex-wrap items-center gap-3">
                    <button
                      type="button"
                      onClick={() => onOpen(a)}
                      className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
                    >
                      <i className="ri-book-open-line h-4 w-4"></i>
                      打开深度解析
                    </button>
                    <button
                      type="button"
                      onClick={() => onOpen(a)}
                      className="flex items-center gap-1 whitespace-nowrap rounded-md px-3 py-2.5 text-sm font-semibold text-foreground-700 transition-colors hover:text-primary-700"
                    >
                      查看还原时间线
                      <i className="ri-arrow-right-line h-4 w-4"></i>
                    </button>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}